import { EventEmitter } from '@utils/storeManager/subscribeListeners';
import { isClient } from '@utils/window';

const EVENT_NAME = 'AccessTokenDataChange';

class AccessTokenManager extends EventEmitter {
  private static instance: AccessTokenManager;

  private key = 'accessToken';

  private constructor() {
    super();

    if (typeof window !== 'undefined') {
      window.addEventListener(EVENT_NAME, this.handleStorageChange);
    }
  }

  static getInstance(): AccessTokenManager {
    if (!AccessTokenManager.instance) {
      AccessTokenManager.instance = new AccessTokenManager();
    }
    return AccessTokenManager.instance;
  }

  getAccessToken(): string {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(this.key) || '';
    }
    return '';
  }

  removeToken(): void {
    if (!isClient) return;

    localStorage.removeItem(this.key);

    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: null }));

    this.notify();
  }

  setAccessToken(newValue: string): void {
    if (isClient) {
      if (!newValue) {
        this.setTokenClear();
        return;
      }
      const currentData = localStorage.getItem(this.key);
      const newData = JSON.stringify(newValue);

      if (currentData === newData) return;

      localStorage.setItem(this.key, newData);
      window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: newValue }));

      this.notify();
    }
  }

  private setTokenClear() {
    localStorage.removeItem(this.key);
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: '' }));

    this.notify();
  }

  private handleStorageChange = (): void => {
    this.notify();
  };

  destroy(): void {
    super.clearListeners();
    window.removeEventListener(EVENT_NAME, this.handleStorageChange);
  }
}

export default AccessTokenManager.getInstance();
